var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","role":"presentation","aria-labelledby":_vm.icon,"width":_vm.size,"height":_vm.size,"fill":_vm.color}},[_c('use',{attrs:{"href":("#" + _vm.symbolId)}})])}
var staticRenderFns = []

export { render, staticRenderFns }